import 'isomorphic-fetch';
import { ModelYear } from '../typings/general';

interface FetchModelYearOptions {
  readonly faServicesUrl: string;
  readonly apiKey: string;
  readonly serviceConfigsServiceConfig?: string;
}

function createModelYearUrl(
  params: URLSearchParams,
  urlOrigin: string,
): string {
  return `${urlOrigin}/maintenance/years?${params.toString()}`;
}

export async function fetchModelYear({
  faServicesUrl,
  apiKey
}: FetchModelYearOptions): Promise<ModelYear> {
  const params = new URLSearchParams();

  params.set('brand', 'V');
  params.set('importerCode', '444');
  params.set('languageCode', 'en-US');

  const response = await fetch(createModelYearUrl(params, faServicesUrl), {
    headers: { 'x-api-key': apiKey },
  });

  const modelYear = await response.json();

  if (response.status >= 400) throw new Error(modelYear.message);

  return modelYear;
}
